import script from "./ClientLoginRepository.vue?vue&type=script&lang=js"
export * from "./ClientLoginRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__